import { api } from "../app/api";
import { useAsync } from "../app/useAsync";

export function MatchesPage() {
  const { data, error, loading } = useAsync(api.matches, []);
  const matches = data?.matches ?? [];

  return (
    <>
      <h1>Matches</h1>
      <p className="page-sub">
        Sandlot → Shopify customer matching results. Read-only.
      </p>

      {loading && <p className="muted">Loading…</p>}
      {error && <p className="muted">Unavailable ({error}).</p>}

      {!loading && !error && matches.length === 0 && (
        <div className="empty">
          No matches recorded yet. Evaluate customers from the Match Review page
          to populate this table.
        </div>
      )}

      {matches.length > 0 && (
        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Sandlot ID</th>
                <th>Shopify ID</th>
                <th>Confidence</th>
                <th>Status</th>
                <th>Reasons</th>
              </tr>
            </thead>
            <tbody>
              {matches.map((m) => (
                <tr key={m.id}>
                  <td>{m.sandlotCustomerId}</td>
                  <td className="muted">{m.shopifyCustomerId ?? "—"}</td>
                  <td>{m.confidenceScore}</td>
                  <td>{m.matchStatus}</td>
                  <td className="muted">{m.matchReasons ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
